import { GzMultiGaugeWebComponent } from './component/GzMultiGaugeWebComponent';

export { GzMultiGaugeWebComponent };
